<template>
  <div class="my-account">
    <div class="common-box">
      <div class="bread-menu">
        <router-link to="/">首页</router-link>>
        <span>我的账户</span>
      </div>
    </div>
    <div class="user-header">
      <img class="logo is-desktop" :src="`assets/Logo/user-banner-pc.jpg` | ossPath" alt="">
      <img class="logo is-mobile" :src="`assets/Logo/user-banner-mob.jpg` | ossPath" alt="">
      <div class="common-box user-header-info" v-if="isLogin">
        <div class="user-name">
          欢迎您, {{ userInfo.username }} {{ ['', '先生', '女士'][userInfo.gender] }}
        </div>
        <div class="account-points">
          <span class="points_title">当前积分：</span>
          <span class="points_num">{{ crm.points }}</span>
        </div>
      </div>
      <div class="common-box member-level-section">
        <div class="member-level-box">
          <div v-if="isLogin" class="member-level">
            <div :class="['level-name', level > -1 ? 'level-' + level : '']">
              {{ crm.viptypename }}
            </div>
            <router-link :to="{ name: 'MemberBenefits' }" class="deadline-description">
              <span>查看更多会员权益</span>
              <i class="iconfont icon-right-arrow">&#xe628;</i>
            </router-link>
          </div>
          <div class="upgrade-need">
            {{ isLogin ? crm.upgradeNeed : '登录查看会员等级' }}
          </div>
          <div v-if="member_level_list.length" class="member-level-chart">
            <div class="bg-line"></div>
            <div class="process-line" :style="'width:' + processWidth + '%'"></div>

            <div v-for="(item, index) in member_level_list" :key="index"
              :class="'level-item' + (index <= level ? ' level-item-active' : '')"
              :style="'left:' + (10 + (80 / (member_level_list.length - 1)) * index) + '%'">
              <div class="level-item-icon"></div>
              <div class="level-item-name">{{ item.crm_member_level_name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common-box">
      <div class="account-tiles">
        <router-link :to="{ path: '/myaccount' }" class="account-tile">
          <div class="account-tile-icon">
            <i class="iconfont">&#xe656;</i>
          </div>
          <div class="tile-right">
            <div class="account-tile-header">个人信息</div>
            <div class="account-tile-text">完善您的个人信息<br />可获得更多优惠权益</div>
          </div>
        </router-link>
        <router-link :to="{ name: 'MemberBenefits' }" class="account-tile">
          <div class="account-tile-icon">
            <img class="icon" src="@/assets/imgs/icons/member.svg" alt="">
          </div>
          <div class="tile-right">
            <div class="account-tile-header">会员权益</div>
            <div class="account-tile-text">查看您的会员权益<br />解锁更多专享福利</div>
          </div>
        </router-link>
        <router-link :to="{ name: 'Coupons' }" class="account-tile">
          <div class="account-tile-icon">
            <i class="iconfont-ot-website">&#xe6d9;</i>
          </div>
          <div class="tile-right">
            <div class="account-tile-header">我的卡券</div>
            <div class="account-tile-text">您可以查看您的优惠券使用情况</div>
          </div>
        </router-link>
        <router-link :to="{ name: 'Orders' }" class="account-tile">
          <div class="account-tile-icon">
            <i class="iconfont">&#xe659;</i>
          </div>
          <div class="tile-right">
            <div class="account-tile-header">我的订单</div>
            <div class="account-tile-text">您可以根据订单编号和订单状态<br />查看和管理您的订单</div>
          </div>
        </router-link>
        <router-link :to="{ name: 'Addressbook' }" class="account-tile">
          <div class="account-tile-icon">
            <i class="iconfont">&#xe658;</i>
          </div>
          <div class="tile-right">
            <div class="account-tile-header">地址管理</div>
            <div class="account-tile-text">您可以在这里查看、修改或添加<br />您的地址信息</div>
          </div>
        </router-link>
        <router-link :to="{ name: 'Store-finder' }" class="account-tile">
          <div class="account-tile-icon">
            <i class="iconfont">&#xe655;</i>
          </div>
          <div class="tile-right">
            <div class="account-tile-header">附近商店</div>
            <div class="account-tile-text">在这里，你可以找到<br />附近商店购买您所需的商品</div>
          </div>
        </router-link>
      </div>
      <div class="logout-btn" @click="logout">退出登录</div>
      <WXUserCenter :show="wxDialogShow" :data="sendCouponDialogData" @updateShow="updateShow" />
    </div>
  </div>
</template>
<script>
import utils from "@/utils";
import types from '@/store/types';
import WXUserCenter from "@/components/WXUserCenter.vue";

export default {
  components: { WXUserCenter },
  data() {
    return {
      wxDialogShow: false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    crm() {
      return this.$store.state.userInfo?.crm || {};
    },
    member_level_list() {
      return this.crm.member_level_list || [];
    },
    level() {
      return this.member_level_list.findIndex(
        (i) => i.crm_member_level_id == this.crm.viptypecode
      );
    },
    processWidth() {
      if (!this.isLogin) return 0;
      const len = this.member_level_list.length;
      if (this.level >= len - 1) return 100;
      return 10 + (80 / (len - 1)) * (this.level + 0.5);
    },
    sendCouponDialogData() {
      const isBr = utils.isMobile() && utils.isWXBrowser() ? '<br>' : ''
      const describe = `请前往Onitsuka Tiger鬼塚虎官方线上店${isBr}解锁更多会员权益`;
      return {
        title: '会员权益',
        describe: describe,
        imgUrl: 'https://assetsprod.onitsukatiger.com/assets/wechat/usergw/user.png'
      };
    }
  },
  created() {
    this.loadSource();
  },
  methods: {
    logout() {
      this.$store.dispatch(types.LOGOUT, () => {
        this.$store.dispatch(types.GET_CART_INFO);
        this.$router.push({ name: "Home" });
      });
    },
    loadSource() {
      //更新crm会员信息
      this.$store.dispatch(types.GET_PROFILE);
    },
    updateShow(value) {
      this.wxDialogShow = value
    },
  }
};
</script>
<style lang="scss" scoped>
.iconfont,
.iconfont-ot-website {
  font-size: 40px;
  color: #000;
  line-height: 1;
}

.is-desktop {
  display: block;
}

.is-mobile {
  display: none;
}

.common-box {
  max-width: 1200px;
  padding: 0 16px;
  margin: 0 auto;
}

.my-account {

  .bread-menu {
    padding-top: 20px;
    margin-left: 2%;
    display: flex;
    justify-content: flex-start;
    color: #999;

    span {
      color: #333;
    }
  }

  .user-header {
    margin-top: 20px;
    position: relative;
    text-align: left;

    .logo {
      width: 100%;

      &.is-desktop {
        min-height: 300px;
      }

      &.is-mobile {
        min-height: 200px;
      }
    }

    .user-header-info {
      box-sizing: border-box;
      position: absolute;
      bottom: 120px;
      left: 0;
      right: 0;
      color: #fff;

      .user-name {
        display: block;
        text-align: left;
        line-height: 28px;
        font-weight: 500;
        font-size: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .account-points {
        margin-top: 24px;

        .points_title {
          font-weight: 400;
          font-size: 18px;
          line-height: 28px;
        }

        .points_num {
          font-weight: 400;
          font-size: 22px;
          line-height: 28px;
        }
      }
    }

    .member-level-section {
      position: relative;

      .member-level-box {
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: -140px;
        min-height: 150px;
        background: #fff;
        padding: 24px 32px;
        box-shadow: 0px 2px 16px 0px #00000014;
        border-radius: 4px;

        .member-level {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;

          .level-name {
            font-size: 16px;
            line-height: 26px;
            height: 28px;
            padding: 0 13px;
            box-sizing: border-box;
            border: 1px solid #ffffffff;

            &.level-0 {
              border-color: #D3D3D5;
            }

            &.level-1 {
              color: #fff;
              background: linear-gradient(93.08deg, #616161 0%, #C1C1C1 30%, #1B1A1F 100%);
            }

            &.level-2 {
              background: linear-gradient(93.08deg, #B8C1DC 0%, #F5F5F5 30%, #989EB3 100%);
            }

            &.level-3 {
              background: linear-gradient(93.08deg, #FFDCB5 0%, #FFF5E3 30%, #E9BA84 100%);
            }
          }

          .deadline-description {
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: #999999;
            display: flex;
            align-items: center;

            .iconfont{
              font-size: 16px;
              color: #999999;
            }
          }
        }

        .upgrade-need {
          margin-bottom: 40px;
          font-size: 18px;
          line-height: 24px;
          color: #212322;
        }

        .member-level-chart {
          position: relative;
          padding: 6px 0 34px;

          .bg-line {
            background: #EEEEEE;
            width: 100%;
            height: 5px;
            border-radius: 100px;
          }

          .process-line {
            position: absolute;
            left: 0;
            top: 6px;
            background: #212322;
            height: 5px;
            border-radius: 100px;
          }

          .level-item {
            position: absolute;
            top: 0;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;

            &-icon {
              width: 16PX;
              height: 16PX;
              border-radius: 100px;
              background-color: #BFC0C4;
              position: relative;

              &:after {
                content: '';
                position: absolute;
                width: 8PX;
                height: 8PX;
                border-radius: 100px;
                background-color: #fff;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
              }
            }

            &-name {
              font-size: 14px;
              line-height: 20px;
              color: #4B4F54;
              margin-top: 9px;
              white-space: nowrap;
            }

            &.level-item-active {
              .level-item-icon {
                background-color: #212322;
              }
            }
          }
        }
      }
    }
  }

  .account-tiles {
    margin-top: 200px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .account-tile {
      display: flex;
      justify-content: space-between;
      border: 1px solid #ACACAC;
      border-radius: 4px;
      padding: 30px;
      box-sizing: border-box;

      &:hover {
        cursor: pointer;
        border: 1px solid #000;
        transition: border 0.3s;
      }

      .account-tile-icon {
        text-align: center;

        .icon {
          width: 40px;
          display: inline-block;
        }
      }

      .account-tile-header {
        color: #212322;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
      }

      .tile-right {
        .account-tile-text {
          color: #666;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .logout-btn {
    margin-top: 60px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-decoration: underline;
    cursor: pointer;
    color: #212322;
  }
}

@media only screen and (max-width: 768px) {

  .iconfont,
  .iconfont-ot-website {
    font-size: 20px;
  }

  .is-desktop {
    display: none;
  }

  .is-mobile {
    display: block;
  }

  .my-account {
    .user-header {
      .user-header-info {
        bottom: 90px;

        .user-name {
          font-size: 16px;
          line-height: 28px;
        }

        .account-points {
          margin-top: 12px;

          .points_title {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
          }

          .points_num {
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
          }
        }
      }

      .member-level-section {

        .member-level-box {
          bottom: -60px;
          min-height: 86px;
          padding: 14px 12px;
          box-shadow: 0px 1px 10px 0px #00000014;

          .member-level {
            margin-bottom: 8px;

            .level-name {
              font-size: 10px;
              line-height: 14px;
              height: 16px;
              padding: 0 8px;
            }

            .deadline-description {
              font-size: 11px;
              line-height: 16px;
              
              .iconfont{
                font-size: 12px;
              }
            }
          }

          .upgrade-need {
            margin-bottom: 20px;
            font-size: 12px;
            line-height: 16px;
          }

          .member-level-chart {
            padding: 3px 0 20px;

            .bg-line {
              height: 4px;
            }

            .process-line {
              top: 3px;
              height: 4px;
            }

            .level-item {
              &-icon {
                width: 10PX;
                height: 10PX;

                &:after {
                  width: 4PX;
                  height: 4PX;
                }
              }

              &-name {
                font-size: 10px;
                line-height: 10px;
                margin-top: 5px;
              }
            }
          }
        }
      }
    }

    .account-tiles {
      margin-top: 100px;
      grid-template-columns: repeat(2, 1fr);
      row-gap: 16px;

      .account-tile {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        height: 100px;
        padding: 30px 20px;

        .account-tile-icon {
          text-align: left;

          .icon {
            width: 20px;
          }
        }

        .account-tile-header {
          font-size: 14px;
          line-height: 20px;
        }

        .account-tile-text {
          display: none;
        }
      }
    }

    .logout-btn {
      margin-top: 36px;
      font-size: 12px;
    }
  }
}

@media only screen and (min-width: 768px) {
  .my-account {
    .account-tiles {

      .account-tile {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 250px;
        box-sizing: border-box;
        padding: 57px 20px;

        .account-tile-icon,
        .account-tile-header {
          width: 100%;
          text-align: center;
        }

        .account-tile-icon {
          margin-bottom: 20px;
        }

        .account-tile-header {
          margin-bottom: 12px;
        }

        .tile-right {
          text-align: center;
          width: 100%;
        }
      }
    }
  }
}
</style>
